import * as React from 'react';
import withStyles from 'react-jss';
import { StylesProps } from 'src/Library/Types';
import {
  Modal,
  Button,
  Icon,
  Spin,
} from 'src/Library/AntdLibComponents';
import { uploadSIModalStyles } from './UploadSIModal.styles';
import classNames from 'classnames';
import { connect } from 'react-redux';

interface IProps extends StylesProps<ReturnType<typeof uploadSIModalStyles>> {
  isVisible: boolean;
  onOkay: () => void;
  inttraRefNumber: string;
  openDocumentTab: () => void;
  handleCreateNewRequest: () => void;
  isAmend?: boolean;
  isRetryError?: boolean;
  pendingContainerCount: number;
  isFetchingContainerCount?: boolean;
}

const UploadSISuccessModal = (props: IProps): React.ReactElement => {

  const {
    classes,
    isVisible,
    onOkay,
    inttraRefNumber,
    openDocumentTab,
    handleCreateNewRequest,
    isAmend,
    isRetryError,
    pendingContainerCount,
    isFetchingContainerCount,
  } = props;

  const renderTitle = () : React.ReactElement => {
    return (
      <div className={classes.successHeader} style={{ display: 'flex' }}>
        <Icon type="check-circle" style={{ color: '#52C41A', marginRight: '8px', fontSize: '18px' }}
          theme="filled" />
        Shipping Instructions
        {inttraRefNumber && <span>
          <span style={{ fontWeight: 600 }}> with INNTRA# {inttraRefNumber}</span>
        </span>}
        &nbsp;has been successfully {isAmend ? 'amended' : 'requested'}
      </div>
    );
  };

  return (
    <Modal
      visible={isVisible}
      zIndex={1200}
      width={400}
      className={(isAmend || isRetryError) ?
        classes.successModal : classNames(classes.successModal, classes.successModalBody )}
      title={renderTitle()}
      onCancel={() => onOkay()}
      closable={false}
      footer={
        <Button
          className={classes.successButton}
          onClick={() => onOkay()}
        >
          Okay
        </Button>
      }
    >
      {!(isAmend || isRetryError) && <div style={{ paddingBottom: '16px' }}>
        <div style={{ fontWeight: 600, color: '#424242', fontSize: '12px' }}>Suggested Actions</div>
        <div className={classes.suggestedActionsDiv}>
          <div
            className={classes.suggestedActions}
            style={{ marginRight: '16px' }}
            onClick={() => {
              openDocumentTab();
              onOkay();
            }}
          >
            <Icon type="file-text" style={{ color: '#1890FF', marginRight: '6px' }} />
            View Request
          </div>
          {isFetchingContainerCount ? <Spin size="small" /> : (pendingContainerCount > 0 && <div
            className={classes.suggestedActions}
            onClick={() => {
              onOkay();
              handleCreateNewRequest();
            }}
          >
            <Icon type="plus" style={{ color: '#1890FF', marginRight: '6px' }} />
            Create New Request
          </div>)}
        </div>
      </div>}
    </Modal>
  );
};

const mapStateToProps = ({ shipmentExecutionReducer }, ownProps) => ({
  pendingContainerCount: shipmentExecutionReducer.siPendingCount?.SI?.pendingContainerCount,
  isFetchingContainerCount: shipmentExecutionReducer?.isFetchingContainerCount,
});


export default connect(
  mapStateToProps,
  null,
)(React.memo(withStyles(uploadSIModalStyles)(UploadSISuccessModal)));
